import { z } from "zod/v4";

// Schema for the currentUser.emersonMigrationStatus
const emersonMigrationStatusSchema = z.object({
  step: z.string(),
});

const currentUserSchema = z.object({
  emersonMigrationStatus: emersonMigrationStatusSchema.optional().nullable(),
  fullName: z.string().optional().nullable(),
});

const currentRoleSchema = z.object({
  id: z.string(),
  storeId: z.string().optional().nullable(),
});

// Schema for the initialProps data from the GraphQL query
const initialPropsSchema = z.object({
  currentUser: currentUserSchema.optional().nullable(),
  currentRole: currentRoleSchema.optional().nullable(),
});

// Main loader schema
export const loaderSchema = z.object({
  initialProps: initialPropsSchema.optional(),
  googleMapsApiPubKey: z.string().optional(),
  taxComplianceEmail: z.string().optional(),
  googleTagManager: z.string().optional(),
});

export type LoaderData = z.infer<typeof loaderSchema>;
